// EmailLookupGrid.jsx
import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import Elv3FormField from "./Elv3FormField";
import { emailDisplayConfig } from "../../config/Elv3config";

const EmailLookupGrid = ({
  formData,
  handleSectionInputChange, // if still needed for non-profile fields
  handleProfileConfirmed,
  dobProfiles, // New prop
}) => {
  // Determine if any device in the elv3List has InspectionTypeID of "7" (Periodic Inspection)
  const isPeriodic =
    formData.elv3List &&
    formData.elv3List.some((item) => item.InspectionTypeID === "7");

  // Create a new config array starting with the existing emailDisplayConfig entries.
  const configArray = [...emailDisplayConfig];
  if (isPeriodic) {
    // Append the Maintenance Director Information section if a periodic inspection is selected.
    configArray.push({
      title: "Maintenance Director Information",
      section: "PerformingMaintenanceDirectorInformation",
    });
  }

  return (
    <Grid container spacing={2}>
      {configArray.map((config, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Box border="1px solid #ccc" borderRadius={1} p={2}>
            <Typography variant="h6" gutterBottom>
              {config.title}
            </Typography>
            <Elv3FormField
              sectionName={config.section}
              onProfileConfirmed={handleProfileConfirmed}
              dobProfiles={dobProfiles} // Pass profiles down to each field
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default EmailLookupGrid;
